import { useState, useEffect } from "react";
import moment from "moment";
import InputNumber from "../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../shared/components/inputs/InputText/InputText";
import { Link } from "react-router-dom";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import toast from "react-hot-toast";
import { useLoading } from "../../../../../shared/context/LoadingContext";

import { fixSpaces } from "../../../../../shared/util/helperFunctions";

import "./ModalEntrada.scss";

function ModalEntrada({
  openModalEntrada,
  handleCloseModalEntrada,
  sendRequest,
  clinicaId,
  updateEntradas,
  auth,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalEntrada);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [caixaClinicaId, setCaixaClinicaId] = useState();

  const [dataLimitePagamento, setDataLimitePagamento] = useState(
    moment().add(1, "M")
  );

  const [clientesFornecedores, setClientesFornecedores] = useState([]);
  const [clienteFornecedor, setClienteFornecedor] = useState();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [
          categoriasResponse,
          clientesFornecedoresResponse,
          caixasResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientesfornecedores/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          })
        );

        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process clientesFornecedores
        const clientesFornecedoresFormatted =
          clientesFornecedoresResponse.clientesFornecedores.map((cf) => ({
            id: cf.id,
            value: cf.nome,
          }));
        setClientesFornecedores(clientesFornecedoresFormatted);
        setClienteFornecedor(
          clientesFornecedoresFormatted[0] || { id: "", value: "" }
        );

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));
        const caixaClinica = caixasFormatted.filter(
          (c) => c.value === "Clínica"
        );

        setCaixaClinicaId(caixaClinica[0].id);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalEntrada);
  }, [openModalEntrada]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  const guardarEntradaHandler = async (emit) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("tipo", "clienteFornecedor");
      formData.append("clinica", clinicaId);
      formData.append("observacoes", observacao ? observacao : "");
      formData.append("valor", valor);
      formData.append("descricao", fixSpaces(descricao));
      formData.append("dataLimitePagamento", dataLimitePagamento);
      formData.append("criadoPor", auth.userId);

      formData.append("categoria", categoria);
      formData.append("caixa", caixaClinicaId);
      formData.append(
        "clienteFornecedor",
        clienteFornecedor.id ? clienteFornecedor.id : clienteFornecedor
      );
      formData.append("entradaRecebida", false);

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      let entradaAdicionada;
      try {
        entradaAdicionada = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas`,
          "POST",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
      } catch (err) {
        console.error("err", err);
      }

      if (emit) {
        updateEntradas(entradaAdicionada.entrada, "emitirFTEDireto");
      } else {
        toast.success("Entrada adicionada com sucesso!");
        updateEntradas(entradaAdicionada.entrada, "inserir");
        stopLoading();
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmitting(false);
      handleCloseModalEntrada();
    }
  };

  const preGuardarEntradaHandler = (e, emit) => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da entrada não pode ser 0 ou menor que 0.");
    } else if (!descricao || descricao.trim() === "") {
      toast.error("Introduza a descrição");
    } else if (!clienteFornecedor) {
      toast.error("Escolha o Cliente Financeiro");
    } else if (!dataLimitePagamento) {
      toast.error("Introduza a data de limite de pagamento");
    } else if (
      !moment.isMoment(dataLimitePagamento) ||
      !dataLimitePagamento.isValid()
    ) {
      toast.error("Introduza a data de limite de pagamento corretamente");
    } else if (!categoria) {
      toast.error("Introduza uma categoria");
    } else if (!isSubmitting) {
      // Prosseguir normalmente
      setIsSubmitting(true);
      guardarEntradaHandler(emit);
    }
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalEntrada}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-entrada__modal"
          id="modal__adicionar-entrada"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Nova entrada - Cliente Financeiro
          </h1>

          <div className="adicionar-entrada__modal__container">
            <InputText
              className="adicionar-entrada__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />

            {clientesFornecedores && clienteFornecedor && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setClienteFornecedor(e.target.value)}
                  className="customInputSelect"
                  value={clienteFornecedor}
                >
                  {clientesFornecedores &&
                    clienteFornecedor &&
                    clientesFornecedores.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">
                  Cliente Financeiro
                </label>
                <Link to={`../../configuracoes/fornecedores`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            <InputNumber
              className="adicionar-entrada__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-entrada__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data limite pagamento*"
                inputFormat="DD-MM-YYYY"
                value={dataLimitePagamento}
                onChange={(value) => setDataLimitePagamento(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            {categorias && categoria && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
                <Link to={`../../configuracoes/categoriasFinanceiro`}>
                  <ControlPointIcon className="customInputPlusSign" />
                </Link>
              </div>
            )}

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-entrada__modal__container__textarea"
            ></textarea>
          </div>

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalEntrada}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarEntradaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
            <span
              disabled={isSubmitting}
              className={"blue-button"}
              onClick={preGuardarEntradaHandler.bind(null, null, "emitirFTE")}
            >
              {isSubmitting
                ? "Guardando..."
                : `Guardar e emitir FTE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalEntrada;
